import React, { useState } from 'react';

import { IconButton, ClickAwayListener, InputAdornment } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, TextField } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: { marginRight: theme.spacing(2) },
  active: {
    display: 'flex'
  }
}));

function EndAdornment ({ handleClose }: { handleClose: () => void }) {
  return (
    <InputAdornment position='end'>
      <IconButton size='small' onClick={handleClose}>
        <Icon type='cross' size='sm' color='secondary' />
      </IconButton>
    </InputAdornment>
  );
}

interface QuerySearchProps {
  querySearch: string
  setQuerySearch: (query: string) => void
}

export default function QuerySearch ({ querySearch, setQuerySearch }: QuerySearchProps) {
  const classes = useStyles();
  const [active, setActive] = useState(false);
  const handleChange = (event: any) => {
    setQuerySearch(event.target.value);
  };

  const handleClose = () => {
    setQuerySearch('');
    setActive(false);
  };

  const handleClickAway = () => {
    if (!querySearch) {
      handleClose();
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Escape') {
      handleClose();
    }
  };

  const handleSearchClick = () => {
    setActive(true);
  };

  return (
    <div className={classes.root}>
      <ClickAwayListener onClickAway={handleClickAway}>
        {active
          ? (
            <div className={classes.active}>
              <IconButton size='medium'>
                <Icon type='search' size='md' />
              </IconButton>
              <TextField
                margin='none'
                disableShadow
                autoFocus
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                value={querySearch}
                InputProps={{
                  endAdornment: <EndAdornment handleClose={handleClose} />
                }}
              />
            </div>
            )
          : (
            <IconButton size='medium' onClick={handleSearchClick}>
              <Icon type='search' size='md' />
            </IconButton>
            )}
      </ClickAwayListener>
    </div>
  );
}
